import { slaGroupApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { showMessageAction } from 'store/global/actions';

export const SLA_GROUPS_ACTION_TYPE = createNamedActions('slaGroups', {
  GET_SLA_GROUPS: 'GET_SLA_GROUPS',
  ADD_SLA_GROUP: 'ADD_SLA_GROUP',
  DELETE_SLA_GROUP: 'DELETE_SLA_GROUP',
  EDIT_SLA_GROUP: 'EDIT_SLA_GROUP',
  REORDER_SLA_GROUP: 'REORDER_SLA_GROUP',
  ADD_SLA_LEVEL: 'ADD_SLA_LEVEL',
  EDIT_SLA_LEVEL: 'EDIT_SLA_LEVEL',
  DELETE_SLA_LEVEL: 'DELETE_SLA_LEVEL',
});

const slaGroups = new schema.Entity('slaGroups', {}, { idAttribute: 'id' });

export const getSlaGroupsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await slaGroupApi.getSlaGroups();

  return dispatch({
    type: SLA_GROUPS_ACTION_TYPE.GET_SLA_GROUPS,
    payload: normalize(data, [slaGroups]).entities.slaGroups,
  });
});

export const addSlaGroupAction = catchAsyncActionError(body => async dispatch => {
  const { data } = await slaGroupApi.createSlaGroup(body);

  return dispatch({
    type: SLA_GROUPS_ACTION_TYPE.ADD_SLA_GROUP,
    payload: { ...data, roles: [] },
  });
});

export const editSlaGroupAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await slaGroupApi.editSlaGroup(params);

  return dispatch({
    type: SLA_GROUPS_ACTION_TYPE.EDIT_SLA_GROUP,
    payload: data,
  });
});

export const deleteSlaGroupAction = catchAsyncActionError(({ slaGroupId }) => async dispatch => {
  await slaGroupApi.deleteSlaGroup({ slaGroupId });

  dispatch(
    showMessageAction({
      message: `SLA Group successfully deleted`,
      variant: 'success',
    }),
  );

  return dispatch({
    type: SLA_GROUPS_ACTION_TYPE.DELETE_SLA_GROUP,
    payload: slaGroupId,
  });
});

export const addSlaLevelAction = catchAsyncActionError(body => async dispatch => {
  const { data } = await slaGroupApi.createSlaGroupSlaLevels(body);

  return dispatch({
    type: SLA_GROUPS_ACTION_TYPE.ADD_SLA_LEVEL,
    payload: data,
  });
});

export const editSlaLevelAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await slaGroupApi.editSlaGroupSlaLevels(params);

  return dispatch({
    type: SLA_GROUPS_ACTION_TYPE.EDIT_SLA_LEVEL,
    payload: data,
  });
});

export const deleteSlaLevelAction = catchAsyncActionError(
  ({ slaGroupId, slaLevelId }) =>
    async dispatch => {
      await slaGroupApi.deleteSlaGroupSlaLevels({ slaGroupId, slaLevelId });

      return dispatch({
        type: SLA_GROUPS_ACTION_TYPE.DELETE_SLA_LEVEL,
        payload: { slaLevelId, slaGroupId },
      });
    },
);

export const reorderSlaLevelsAction =
  ({ list, slaGroupId }) =>
  dispatch =>
    dispatch({
      type: SLA_GROUPS_ACTION_TYPE.REORDER_SLA_GROUP,
      payload: { list, slaGroupId },
    });
